import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { SparkButton, SparkImageLoader } from 'sharedComponents/UI';
import { ActionOptions } from 'types/common';
type BoardNodeFooterProps = { suggestions: ActionOptions[] };

function BoardNodeFooter({ suggestions }: BoardNodeFooterProps) {
  const handleClick = (callback?: () => void) => {
    if (!callback) {
      return;
    }
    callback();
  };

  return (
    <Grid
      container
      bgcolor='white'
      borderRadius='0 0 10px 10px'
      flexWrap='nowrap'
    >
      {suggestions.map((suggestion) => (
        <Grid item>
          <SparkButton
            startIcon={<SparkImageLoader src={suggestion.iconURL} />}
            onClick={() => handleClick(suggestion.onClick)}
          >
            <Typography>{suggestion.label}</Typography>
          </SparkButton>
        </Grid>
      ))}
    </Grid>
  );
}

export default BoardNodeFooter;
